import { lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router'
import { RootLayout } from '@/layouts/root'
import { HomePage } from '@/pages/home'
import { withMinDelay } from '@/utils'

const AboutPage = lazy(() =>
  withMinDelay(import(/* webpackChunkName: 'about', webpackPrefetch: true */ '@/pages/about')).then(module => ({
    default: module.AboutPage,
  })),
)
const NoMatch = lazy(() => withMinDelay(import(/* webpackChunkName: 'no-match', webpackPrefetch: true */ '@/components/no-match')))

export const AppRouter = () => {
  return (
    <BrowserRouter basename={import.meta.env?.__BASENAME__ || ''}>
      <Routes>
        <Route path='/' element={<RootLayout />}>
          <Route index element={<HomePage />} />
          <Route path='about' element={<AboutPage />} />
        </Route>
        <Route path='*' element={<NoMatch />} />
      </Routes>
    </BrowserRouter>
  )
}
